import { Button, Card, Container, Text, Title } from '@mantine/core';

import type { JSX } from "react";

export function AccountDeletionConfirmation(): JSX.Element {
  return (
    <Container size="sm" py="xl">
      <Card withBorder p="xl" radius="md" shadow="sm" ta="center">
        <Title order={2} mb="lg">Account Deletion Requested</Title>
        
        <Text mb="md">
          Your account deletion request has been received. Your account is now deactivated.
        </Text>
        
        <Text size="sm" mb="xl">
          We've sent a confirmation email to your registered email address. Your personal data will be deleted 
          from our systems according to our data retention policy.
        </Text>
        
        <Button component="a" href="/" variant="outline">
          Return to Home Page
        </Button>
      </Card>
    </Container>
  );
}